import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagKM = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M50 24.928H22.898c-5.38 5.38-8.635 9.535-11.957 12.857l14.13 1.273L47 36.884c1.913-3.534 3-7.582 3-11.884v-.072Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M10.942 12.971H46.92C42.668 5.24 34.446 0 25 0A24.917 24.917 0 0 0 7.36 7.287l3.582 5.684Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M12.03 36.883c-2.248 2.247-3.117 4.13-4.743 5.756A24.92 24.92 0 0 0 25 50c9.505 0 17.772-5.305 22-13.116H12.03Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M7.322 7.25c-9.763 9.762-9.763 25.591 0 35.355L25 24.927 7.322 7.249Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M6.594 24.928a7.61 7.61 0 0 1 5.978-7.431 7.609 7.609 0 1 0 0 14.863 7.61 7.61 0 0 1-5.978-7.432Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m12.488 18.407.405 1.245h1.31l-1.06.77.405 1.246-1.06-.77-1.06.77.405-1.246-1.059-.77h1.31l.404-1.245Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m12.488 21.666.405 1.246h1.31l-1.06.77.405 1.245-1.06-.77-1.06.77.405-1.246-1.059-.77h1.31l.404-1.245ZM12.488 24.928l.405 1.245h1.31l-1.06.77.405 1.246-1.06-.77-1.06.77.405-1.246-1.059-.77h1.31l.404-1.245ZM12.488 28.19l.405 1.245h1.31l-1.06.77.405 1.246-1.06-.77-1.06.77.405-1.246-1.059-.77h1.31l.404-1.245Z"
}));
FlagKM.displayName = 'FlagKM';
export default withFlagWrapper(FlagKM);
//# sourceMappingURL=index.js.map